// frontend/admin/src/services/hostingerService.js
// Servicio para consumir las métricas de Hostinger vía el proxy del backend.
// El token de Hostinger NUNCA llega al frontend.

import api from './api.js'

const hostingerService = {
  /**
   * Resumen general para el dashboard:
   * total de websites, subdominios activos y sus detalles.
   */
  async obtenerMetricas() {
    const { data } = await api.get('/admin/hostinger/metricas')
    return data
  },

  /**
   * Lista completa de websites del hosting.
   */
  async obtenerWebsites() {
    const { data } = await api.get('/admin/hostinger/websites')
    return data
  },

  /**
   * Lista de subdominios DNS activos (CNAME/A de sicecom.com).
   */
  async obtenerSubdominios() {
    const { data } = await api.get('/admin/hostinger/subdominios')
    return data
  },
}

export default hostingerService
